import ColumnHeaderMenu from './ColumnHeaderMenu';
import type { ColumnQueryColumn, ColumnQueryState } from './columnQuery';

/** `<th>` cells with Master Inventory Request–style sort/filter menus for `useColumnQuery`. */
export default function ColumnQueryHeaders<Row>({ columns, query, portalTarget }: {
  columns: ReadonlyArray<ColumnQueryColumn<Row>>;
  query: ColumnQueryState;
  /** Pass the open `<dialog>` when the table lives in a modal. */
  portalTarget?: Element | null;
}) {
  return <>
    {columns.map(column => {
      const direction = query.sort?.key === column.key ? query.sort.direction : null;
      return (
        <th key={column.key} scope="col" aria-sort={direction ? (direction === 'asc' ? 'ascending' : 'descending') : undefined}>
          <ColumnHeaderMenu label={column.label} variant="master-inventory" emptyMeansAll portalTarget={portalTarget}
            align={column.align ?? 'left'} sortDirection={direction}
            onSort={next => query.setSort({ key: column.key, direction: next })}
            options={query.options.get(column.key)} selected={query.filters[column.key] ?? []}
            onChangeSelected={column.filterValue ? values => query.setFilter(column.key, values) : undefined} />
        </th>
      );
    })}
  </>;
}
